import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SafetyAnalyticsState } from './models/safety-analytics-state.models';

export const selectSafetyAnalyticsState = createFeatureSelector<SafetyAnalyticsState>('safetyAnalytics');

export const selectSafetySummary = createSelector(
  selectSafetyAnalyticsState,
  (state: SafetyAnalyticsState) => state.summary
);

export const selectSafetyTrend = createSelector(
  selectSafetyAnalyticsState,
  (state: SafetyAnalyticsState) => state.trend
);

export const selectSafetyLoading = createSelector(
  selectSafetyAnalyticsState,
  (state: SafetyAnalyticsState) => state.loading
);

export const selectSafetyError = createSelector(
  selectSafetyAnalyticsState,
  (state: SafetyAnalyticsState) => state.error
);

export const selectSafetyEvents = createSelector(
  selectSafetyAnalyticsState,
  (state: SafetyAnalyticsState) => state.events
);

export const selectSafetyEventsTotal = createSelector(
  selectSafetyAnalyticsState,
  (state: SafetyAnalyticsState) => state.eventsTotal
);
